export enum CreatureTypes {
    Character = 'Character',
    Familiar = 'Familiar',
    AnimalCompanion = 'Companion',
}
